export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10877.cdf4d13b.jpg";